<form [formGroup]="rawmaterialForm" (ngSubmit)="manageRawmaterial()">
  <div fxFlex="1 0 auto" fxLayout="column">
    <div class="neq-page-wrapper" fxFlex="1 1 auto" fxLayout="row">
      <div fxFlex>
        <div class="neq-container">
          <div fxLayout="row">
            {{'label.common.entity' | translate}}
          </div>
          <div *ngIf="entity" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <img *ngIf="entity.logo" [src]="entity.logo" alt="logo"> &nbsp;
            <span class="society">{{entity.name}}</span>
          </div>
          <neq-select-autocomplete (change)="onChangeEntity($event)" *ngIf="canUpdateEntity" [dataSource]="searchEntity"
                                   formControlName="entityCode"></neq-select-autocomplete>

          <div fxLayout="row">
            <div fxFlex="70">
              <mat-form-field>
                <input select-all [placeholder]="'label.common.code' | translate" formControlName="code"
                       (blur)="checkCodeUnicity()" matInput required>
                <mat-error *ngIf="rawmaterialForm.controls.code.errors?.required">{{'error.common.field-required'
                  | translate}}</mat-error>
                <mat-error *ngIf="rawmaterialForm.controls.code.errors?.maxlength" [translateParams]="{param: 50}"
                           translate="error.common.text.max"></mat-error>
                <mat-error *ngIf="rawmaterialForm.controls.code.errors?.pattern">{{'error.common.text.character.invalid'
                  | translate}}</mat-error>
                <mat-error *ngIf="rawmaterialForm.controls.code.errors?.unique">
                  {{'error.common.code.unique'| translate}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row">
            <div fxFlex="70">
              <mat-form-field>
                <input select-all [placeholder]="'label.common.label' | translate" formControlName="label" matInput
                       required>
                <mat-error *ngIf="rawmaterialForm.controls.label.errors?.required">{{'error.common.field-required'
                  | translate}}</mat-error>
                <mat-error *ngIf="rawmaterialForm.controls.label.errors?.maxlength" [translateParams]="{param: 255}"
                           translate="error.common.text.max"></mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row">
            <div fxFlex="50">
              <div class="mat-form-field" fxFlex="95" fxLayout="column" fxLayoutAlign="center none">
                <div fxLayout="row"><span>{{'label.common.reference' | translate}} *</span></div>
                <div fxLayout="row" fxLayoutAlign="start center">
                  <neq-select-autocomplete (change)="onChange($event)" [dataSource]="search"
                                           formControlName="reference" fxFlex>
                  </neq-select-autocomplete>

                  <neq-icon (click)="openAdvancedReferenceSearch()" (keyDown)="openAdvancedReferenceSearch()"
                            [matTooltip]="'label.common.search.advanced' | translate"
                            svgIcon="recherche"></neq-icon>
                </div>
                <neq-form-errors-messages
                  [messageList]="messageListReference"
                  [entryFormGroup]="rawmaterialForm"
                  [entryFormGroupName]="'reference'"
                  [check]="check"
                ></neq-form-errors-messages>
              </div>
            </div>
            <div *ngIf="selected" fxFlex="50">
              <mat-form-field>
                <input [placeholder]="'label.common.reference.description' | translate" disabled
                       matInput value="{{selected?.description}}">
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="selected" fxLayout="row">
            <div fxFlex="50">
              <mat-form-field>
                <input [placeholder]="'label.common.reference.prediction-model' | translate" disabled
                       matInput value="{{selected?.predictionModelLabel}}">
              </mat-form-field>
            </div>
            <div fxFlex="50" *ngIf="selected.predictionModelDescription" >
              <mat-form-field>
                <input [placeholder]="'label.common.prediction-model.description' | translate" disabled
                       matInput value="{{selected?.predictionModelDescription}}">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <aside fxFlex="290px">
        <div class="neq-action-button" fxLayoutAlign="end center">
          <button pButton
            [disabled]="rawmaterialForm.pristine"
            class="neq-primeng-button primeng-flat"
            [matTooltip]="'msg.common.icon.save' | translate"
            type="submit"
          >
            <neq-icon svgIcon="enregistrer"></neq-icon>
          </button>
        </div>
        <neq-event-list [auditableDto]="rawMaterial"></neq-event-list>


        <div *ngIf="error" class="neq-container neq-aside-container neq-info-container {{error.type}}" fxLayout="row">
          <neq-icon svgIcon="alerte"></neq-icon>
          <span>{{error.message}}</span>
        </div>

        <div class="neq-container neq-aside-container">
          <h3>
            <neq-icon svgIcon="notes"></neq-icon>&nbsp;{{ 'label.common.notes' | translate }}
          </h3>
          <textarea select-all matInput formControlName="notes"></textarea>
        </div>
      </aside>
    </div>
  </div>
</form>
